import { render, staticRenderFns } from "./PostQuestion.vue?vue&type=template&id=15c1c178&scoped=true"
import script from "./PostQuestion.vue?vue&type=script&lang=js"
export * from "./PostQuestion.vue?vue&type=script&lang=js"
import style0 from "./PostQuestion.vue?vue&type=style&index=0&id=15c1c178&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c1c178",
  null
  
)

export default component.exports